Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFont = void 0;
var useFont = exports.useFont = function useFont() {
  var fontRegular = {
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontStyle: 'normal'
  };
  var fontRegularItalic = {
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontStyle: 'italic'
  };
  var fontSemiBold = {
    fontFamily: 'Poppins',
    fontWeight: '600',
    fontStyle: 'normal'
  };
  var fontBold = {
    fontFamily: 'Poppins',
    fontWeight: '700',
    fontStyle: 'normal'
  };
  return {
    fontRegular: fontRegular,
    fontRegularItalic: fontRegularItalic,
    fontSemiBold: fontSemiBold,
    fontBold: fontBold
  };
};